import Grid from 'components/Grid'
import StoreCard from 'components/StoreCard'
import { ESmallCardType, MbSmallCard } from 'mintbase-ui'
import { useLatestStoresController } from '../controllers/LatestStoreController'
import { FilterOptions } from '../types/Marketplace.type'

const LoadingStores = ({ itemsPerPage }: { itemsPerPage: number }) => {
  const lists = Array.from(Array(itemsPerPage).keys())
  return (
    <>
      {lists.map(() => (
        <MbSmallCard
          key={'ele'}
          loading={true}
          cardType={ESmallCardType.STORE}
          card={null}
        />
      ))}
    </>
  )
}

const LatestStores = ({
  filter = FilterOptions.NEWEST,
  page: initialPageIndex,
}: {
  filter: FilterOptions
  page: number
}) => {
  const { data, loading, itemsPerPage } = useLatestStoresController({
    filter: filter,
  })

  return (
    <Grid>
      {loading && <LoadingStores itemsPerPage={itemsPerPage} />}
      {!loading &&
        data?.map((store, index) => {
          return (
            <StoreCard
              key={`${index}${store.id}`}
              id={store.id}
            />
          )
        })}
    </Grid>
  )
}

export default LatestStores
